
<template>
  <v-container fluid  >
    <v-row justify="center">

      <!-- Contenido principal -->
      <v-col cols="12" md="8">
        <v-card class="pa-5" elevation="4" shaped>

          <v-card-title class="headline font-weight-bold justify-center">
            Sobre TecZoa
          </v-card-title>

          <!-- Creador -->
          <v-card-subtitle class="title font-weight-bold mt-4">
            Sobre el creador
          </v-card-subtitle>

          <v-card-text class="text-justify">
            💡 Tecnología y emprendimiento | TecZoa.com
            <br>
            🤝 Comunidad AWS User Group Canindeyú
            <br>
            🎓 Universidad • Extensión • Investigación | UNICAN 🇵🇾
            <br><br>

            TecZoa es una iniciativa desarrollada por
            <strong>Magno Portillo</strong>, emprendedor y desarrollador paraguayo
            comprometido con la tecnología, la educación y la construcción de comunidades.
            Su trabajo se enfoca en el desarrollo de soluciones digitales, la participación
            en actividades de extensión e investigación universitaria y el fortalecimiento
            de espacios de aprendizaje y colaboración entre estudiantes, profesionales y emprendedores.
          </v-card-text>

          <v-divider class="my-4"></v-divider>

          <!-- TecZoa Store -->
          <v-card-subtitle class="title font-weight-bold">
            TecZoa Store
          </v-card-subtitle>

          <v-card-text class="text-justify">
            TecZoa Store es una plataforma orientada a la publicación y comercialización
            de productos y servicios, proporcionando un espacio accesible para la promoción
            de iniciativas locales.

            <br><br>

            Actualmente cuenta con dos vendedores registrados:

            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <strong>Magno Portillo</strong>
                  <br>
                  Creador y desarrollador de TecZoa.
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="pink">mdi-heart-pulse</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <strong>Liz Bernal</strong>
                  <br>
                  Servicios de estética y fisioterapia, orientados al bienestar y la salud.
                </v-list-item-content>
              </v-list-item>
            </v-list>
<!-- 
            La plataforma tiene como objetivo incorporar nuevos emprendedores y profesionales,
            fortaleciendo una comunidad basada en la colaboración y la innovación. -->
          </v-card-text>

          <v-divider class="my-4"></v-divider>

          <!-- LinksTec -->
          <v-card-subtitle class="title font-weight-bold">
            LinksTec
          </v-card-subtitle>

          <v-card-text class="text-justify">
            LinksTec es una herramienta diseñada para centralizar enlaces y recursos digitales
            en una única dirección, permitiendo compartir redes sociales, sitios web, proyectos
            y otros contenidos de forma organizada.

            <br><br>

            Además, dispone de una sección de
            <strong>perfiles públicos</strong>,
            que permite visualizar las iniciativas, proyectos y servicios de profesionales,
            emprendedores y creadores de contenido.

            <br><br>

            Su objetivo es fortalecer la presencia digital y facilitar nuevas conexiones
            dentro de la comunidad, ofreciendo una plataforma sencilla y accesible para
            promover personas, proyectos e iniciativas.
          </v-card-text>

        </v-card>
      </v-col>

      <!-- Columna derecha -->
      <v-col cols="12" md="3">

        <v-card elevation="2" class="mb-4">
          <v-card-title class="subtitle-1 font-weight-bold">
            Ecosistema TecZoa
          </v-card-title>

          <v-card-text>
            <v-chip class="ma-1" color="primary" outlined>
              TecZoa Store
            </v-chip>

            <v-chip class="ma-1" color="success" outlined>
              LinksTec
            </v-chip>

           
          </v-card-text>
        </v-card>

        <!-- Espacio para futuras imágenes o logos -->
        <v-card elevation="2">
          <v-card-title class="subtitle-1 font-weight-bold">
            Próximamente
          </v-card-title>

          <v-card-text class="text-center grey--text">
            Logos, estadísticas, colaboradores y nuevas iniciativas.
          </v-card-text>
        </v-card>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>

